/* =================================================================
   White Cove — theme.js
   Storefront interactions + Shopify AJAX cart.
   ================================================================= */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const routes = window.routes || {};
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    let value = "";
    const fmt = format || window.moneyFormat || "${{amount}}";
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, p, t, d) {
      n = (n || 0).toString();
      p = p == null ? 2 : p;
      t = t == null ? "," : t;
      d = d == null ? "." : d;
      const neg = n.indexOf("-") >= 0 ? "-" : "";
      n = Math.abs(parseFloat(n) / 100).toFixed(p);
      const parts = n.split(".");
      let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t);
      const decimals = parts[1] ? d + parts[1] : "";
      return neg + dollars + decimals;
    }
    const match = fmt.match(placeholder);
    if (!match) return fmt;
    switch (match[1]) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = defaultTo(cents, 0, " "); break;
      default: value = defaultTo(cents, 2);
    }
    // strip tags: stores with HTML money formats would otherwise leak markup into textContent
    return fmt.replace(placeholder, value).replace(/<[^>]*>/g, "");
  }

  /* ---------- HTML escape (user/product strings interpolated into innerHTML) ---------- */
  const ESC_MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" };
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, (c) => ESC_MAP[c]); }

  /* ---------- Shopify CDN image resize ---------- */
  function sizedImg(src, width) {
    if (!src) return "";
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let t = $(".toast");
    if (!t) {
      t = document.createElement("div"); t.className = "toast";
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(t);
    }
    $("span", t).textContent = msg;
    requestAnimationFrame(() => t.classList.add("show"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2200);
  }

  /* ---------- Header reference (scroll handled by the consolidated ticker below) ---------- */
  const header = $("[data-header]");
  const announceEl = $(".announce");
  const headerTrigger = announceEl ? Math.max(0, announceEl.offsetHeight - 1) : 30;

  /* ---------- Announcement marquee: guarantee a seamless loop ----------
     The -50% keyframe only loops cleanly if the track is at least 2x the
     viewport wide. With few/short messages it isn't, which shows as a gap.
     Double the content (keeping the two halves identical) until it is,
     then scale the duration so speed stays constant at any width. */
  const marqueeTrack = announceEl ? $(".announce-track", announceEl) : null;
  if (marqueeTrack && marqueeTrack.children.length) {
    let guard = 0;
    while (marqueeTrack.scrollWidth < window.innerWidth * 2 && guard < 6) {
      Array.from(marqueeTrack.children).forEach((child) => {
        const clone = child.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        marqueeTrack.appendChild(clone);
      });
      guard++;
    }
    marqueeTrack.style.animationDuration = Math.max(18, Math.round(marqueeTrack.scrollWidth / 72)) + "s";
  }

  /* ---------- Hero entrance ---------- */
  const hero = $(".hero");
  const heroMedia = hero ? $(".hero-media", hero) : null;
  if (hero) requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add("loaded")));

  /* ---------- Consolidated scroll (single rAF ticker drives header + parallax + progress) ---------- */
  const progressBar = document.createElement("div");
  progressBar.className = "scroll-progress";
  document.body.appendChild(progressBar);
  let scrollTicking = false;
  function scrollFrame() {
    const y = window.scrollY;
    if (header) header.classList.toggle("scrolled", y >= headerTrigger);
    if (heroMedia && !reduce && y < window.innerHeight) heroMedia.style.transform = "translateY(" + (y * 0.28) + "px)";
    const h = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.transform = "scaleX(" + (h > 0 ? y / h : 0) + ")";
    scrollTicking = false;
  }
  function onScrollTick() { if (!scrollTicking) { scrollTicking = true; requestAnimationFrame(scrollFrame); } }
  window.addEventListener("scroll", onScrollTick, { passive: true });
  scrollFrame();

  /* ---------- Scroll reveal (IO + failsafe) ---------- */
  const REVEAL_SEL = "[data-reveal], [data-clip], [data-split]";
  const supportsIO = "IntersectionObserver" in window;
  const io = supportsIO ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }) : null;

  function splitHeading(el) {
    if (el.dataset.split === "done" || el.children.length) { el.dataset.split = "done"; return; }
    const words = el.textContent.trim().split(/\s+/);
    if (!words.length) return;
    el.textContent = "";
    words.forEach((w, i) => {
      const mask = document.createElement("span");
      mask.className = "line-mask"; mask.style.display = "inline-block";
      const inner = document.createElement("span");
      inner.textContent = w; inner.style.transitionDelay = (i * 0.045) + "s";
      mask.appendChild(inner); el.appendChild(mask);
      if (i < words.length - 1) el.appendChild(document.createTextNode(" "));
    });
    el.dataset.split = "done";
  }
  if (!reduce) $$(".sec-head h2, .page-head h1").forEach(splitHeading);

  function revealInView() {
    const vh = window.innerHeight;
    $$(REVEAL_SEL).forEach((el) => {
      if (el.classList.contains("in")) return;
      const r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add("in");
    });
  }
  function watchReveals() {
    $$(REVEAL_SEL).forEach((el) => { if (io) io.observe(el); else el.classList.add("in"); });
    revealInView();
  }
  // Reveals are driven by IntersectionObserver; this load pass is just a failsafe.
  window.addEventListener("load", () => setTimeout(revealInView, 250));

  /* ---------- Mobile nav ---------- */
  const burger = $("[data-burger]");
  const mnav = $("[data-mobile-nav]");
  if (burger && mnav) {
    const toggle = (open) => {
      mnav.classList.toggle("open", open);
      burger.classList.toggle("active", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
    };
    burger.addEventListener("click", () => toggle(!mnav.classList.contains("open")));
    $$("a", mnav).forEach((a) => a.addEventListener("click", () => toggle(false)));
    $$("[data-nav-close]", mnav).forEach((b) => b.addEventListener("click", () => toggle(false)));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && mnav.classList.contains("open")) toggle(false); });

    // Accordion: tap a category to expand its sub-links (single panel open at a time)
    const accBtns = $$("[data-m-acc]", mnav);
    accBtns.forEach((btn) => {
      const panel = btn.nextElementSibling;
      btn.addEventListener("click", () => {
        const isOpen = btn.getAttribute("aria-expanded") === "true";
        accBtns.forEach((other) => {
          if (other !== btn) {
            other.setAttribute("aria-expanded", "false");
            const p = other.nextElementSibling;
            if (p) p.style.maxHeight = "0px";
          }
        });
        btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
        if (panel) panel.style.maxHeight = isOpen ? "0px" : panel.scrollHeight + "px";
      });
    });
  }

  /* ---------- Accordion ---------- */
  $$(".acc-q").forEach((q) => q.addEventListener("click", () => {
    const item = q.closest(".acc-item");
    const a = $(".acc-a", item);
    const open = item.classList.toggle("open");
    a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
  }));

  /* =================================================================
     CART DRAWER + AJAX
     ================================================================= */
  const overlay = $("[data-overlay]");
  const drawer = $("[data-cart-drawer]");
  const drawerBody = $("[data-cart-body]");
  const countEls = $$("[data-cart-count]");
  const subtotalEl = $("[data-cart-subtotal]");

  function openDrawer() { overlay && overlay.classList.add("open"); drawer && drawer.classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeDrawer() { overlay && overlay.classList.remove("open"); drawer && drawer.classList.remove("open"); document.body.style.overflow = ""; }

  $$("[data-open-cart]").forEach((b) => b.addEventListener("click", (e) => {
    // allow normal navigation if JS cart unavailable; otherwise open drawer
    if (!drawer) return;
    e.preventDefault(); refreshCart().then(openDrawer);
  }));
  $("[data-cart-close]") && $("[data-cart-close]").addEventListener("click", closeDrawer);
  overlay && overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer && drawer.classList.contains("open")) { closeDrawer(); } });

  function cartLineHTML(item, index) {
    const meta = item.variant_title && item.variant_title !== "Default Title" ? '<div class="cart-line-meta">' + esc(item.variant_title) + "</div>" : "";
    const img = item.image ? '<img src="' + sizedImg(item.image, 200) + '" alt="" loading="lazy">' : "";
    return '<div class="cart-line" data-key="' + item.key + '" data-line="' + index + '">' +
      '<a class="cart-line-img" href="' + item.url + '">' + img + "</a>" +
      "<div>" +
        '<a class="cart-line-name" href="' + item.url + '">' + esc(item.product_title) + "</a>" + meta +
        '<div class="cart-qty">' +
          '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-qty-up aria-label="Increase">+</button>' +
        "</div>" +
      "</div>" +
      '<div style="text-align:right">' +
        '<div class="cart-line-price">' + (item.original_line_price > item.final_line_price ? '<span class="cart-was">' + formatMoney(item.original_line_price) + "</span> " : "") + formatMoney(item.final_line_price) + "</div>" +
        '<button class="cart-remove" type="button" data-remove>Remove</button>' +
      "</div>" +
    "</div>";
  }

  const CHECK_SM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>';
  function updateShipBar(totalPrice, itemCount) {
    const bar = $("[data-ship-bar]");
    if (!bar) return;
    const threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (threshold <= 0) return;
    // hidden while the bag is empty
    bar.style.display = itemCount > 0 ? "" : "none";
    if (itemCount === 0) return;
    const fill = $("[data-ship-fill]", bar);
    const msg = $("[data-ship-msg]", bar);
    const pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
    if (fill) fill.style.width = pct + "%";
    const remaining = threshold - totalPrice;
    if (remaining > 0) {
      bar.classList.remove("is-free");
      if (msg) msg.innerHTML = "You&rsquo;re <strong>" + formatMoney(remaining) + "</strong> away from <strong>complimentary shipping</strong>";
    } else {
      bar.classList.add("is-free");
      if (msg) msg.innerHTML = CHECK_SM + " Complimentary shipping unlocked";
    }
  }

  function renderCart(cart) {
    if (!drawerBody) return;
    countEls.forEach((el) => { el.textContent = cart.item_count; el.classList.toggle("show", cart.item_count > 0); });
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateShipBar(cart.total_price, cart.item_count);
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="drawer-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your bag is empty.</p><div class="drawer-empty-ctas"><a class="btn btn-dark" href="/collections/dresses"><span class="btn-label">Shop dresses</span></a><a class="btn btn-light" href="/collections/jewellery"><span class="btn-label">Shop jewellery</span></a></div></div>';
      return;
    }
    drawerBody.innerHTML = cart.items.map((item, i) => cartLineHTML(item, i + 1)).join("");
  }

  function refreshCart() {
    return fetch(routes.cart_url + ".js", { headers: { "Accept": "application/json" } })
      .then((r) => r.json()).then((cart) => { renderCart(cart); return cart; })
      .catch(() => {});
  }

  function changeLine(line, quantity) {
    if (!drawer) return;
    const lineEl = $('.cart-line[data-line="' + line + '"]', drawerBody);
    if (lineEl) lineEl.classList.add("is-loading");
    return fetch(routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then((r) => {
      if (!r.ok) return r.json().then((err) => { throw err; });
      return r.json();
    }).then((cart) => { renderCart(cart); return cart; }).catch((err) => {
      if (lineEl) lineEl.classList.remove("is-loading");
      toast((err && err.description) || window.cartStrings.error);
    });
  }

  if (drawer) {
    drawer.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-qty-up], [data-qty-down], [data-remove]");
      if (!btn) return;
      const lineEl = e.target.closest(".cart-line");
      if (!lineEl) return;
      const line = parseInt(lineEl.dataset.line, 10);
      const current = parseInt($(".cart-qty span", lineEl).textContent, 10) || 1;
      if (btn.hasAttribute("data-qty-up")) changeLine(line, current + 1);
      else if (btn.hasAttribute("data-qty-down")) changeLine(line, Math.max(0, current - 1));
      else if (btn.hasAttribute("data-remove")) changeLine(line, 0);
    });
  }

  function addItems(items) {
    return fetch(routes.cart_add_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then((r) => {
      if (!r.ok) return r.json().then((err) => { throw err; });
      window.wcAddedToCart = true; // suppresses the newsletter popup for this visit
      return r.json();
    });
  }

  /* ---------- Quick add from product cards / look ---------- */
  const CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>';
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    if (btn.tagName === "A") return; // "Choose options" link — let it navigate
    const id = btn.getAttribute("data-quick-add");
    if (!id) return;
    e.preventDefault();
    const iconOnly = btn.classList.contains("look-add") || btn.classList.contains("cart-up-add") || btn.classList.contains("quick-add");
    btn.disabled = true;
    // capture pristine markup once, so a click during the "Added" state can't overwrite it
    if (!btn.dataset.origHtml) btn.dataset.origHtml = btn.innerHTML;
    addItems([{ id: id, quantity: 1 }]).then(refreshCart).then(() => {
      btn.disabled = false;
      btn.classList.add("added");
      btn.innerHTML = iconOnly ? CHECK : CHECK + " Added";
      setTimeout(() => { btn.classList.remove("added"); btn.innerHTML = btn.dataset.origHtml; }, 1500);
      openDrawer();
    }).catch(() => { btn.disabled = false; btn.innerHTML = btn.dataset.origHtml; toast(window.cartStrings.error); });
  });

  /* ---------- Add the look ---------- */
  const addLookBtn = $("[data-add-look]");
  if (addLookBtn) {
    addLookBtn.addEventListener("click", () => {
      const items = [];
      const mainId = $("[data-variant-id]");
      if (mainId && mainId.value) items.push({ id: mainId.value, quantity: 1 });
      $$("[data-look-add]").forEach((b) => { const id = b.getAttribute("data-quick-add"); if (id) items.push({ id: id, quantity: 1 }); });
      if (!items.length) return;
      addLookBtn.disabled = true;
      addItems(items).then(refreshCart).then(() => { addLookBtn.disabled = false; toast("The look is in your bag ✦"); openDrawer(); })
        .catch(() => { addLookBtn.disabled = false; toast(window.cartStrings.error); });
    });
  }

  /* =================================================================
     PRODUCT PAGE
     ================================================================= */
  const productInfo = $("[data-product-info]");
  if (productInfo) {
    let variants = [];
    const dataEl = $("[data-product-json]");
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    const form = $(".product-form", productInfo);
    const variantInput = $("[data-variant-id]", productInfo);
    const priceEl = $("[data-current-price]", productInfo);
    const compareEl = $("[data-compare-price]", productInfo);
    const addBtn = $("[data-add-btn]", productInfo);
    const addLabel = $("[data-add-label]", productInfo);
    const mainImg = $("[data-main-img]", productInfo);
    const stickyPrice = $("[data-sticky-price]");
    const stickyAdd = $("[data-sticky-add]");
    const selected = [];

    // init selected from active buttons (size + colour swatch rows)
    const OPT_SEL = ".size-opt, .swatch-opt";
    $$(".size-row", productInfo).forEach((row) => {
      const idx = parseInt(row.dataset.optionIndex, 10);
      const active = $(".size-opt.active, .swatch-opt.active", row);
      const first = $(OPT_SEL, row);
      selected[idx] = active ? active.dataset.optionValue : (first ? first.dataset.optionValue : undefined);
    });

    function currentVariant() {
      if (!variants.length) return null;
      if (!$(".size-row", productInfo)) return variants[0];
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }

    function updateVariant() {
      const v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = "Unavailable";
        if (stickyAdd) stickyAdd.disabled = true;
        if (variantInput) variantInput.value = "";
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.style.display = ""; }
        else compareEl.style.display = "none";
      }
      const saveLine = $("[data-save-line]", productInfo);
      if (saveLine) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          const amt = $("[data-save-amount]", saveLine);
          if (amt) amt.textContent = formatMoney(v.compare_at_price - v.price);
          saveLine.style.display = "";
          if (priceEl) priceEl.classList.add("now");
        } else {
          saveLine.style.display = "none";
          if (priceEl) priceEl.classList.remove("now");
        }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? "Add to bag" : "Sold out";
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.src = sizedImg(v.featured_image.src, 1200);
      }
    }

    $$(".size-row", productInfo).forEach((row) => {
      const idx = parseInt(row.dataset.optionIndex, 10);
      const isColor = row.hasAttribute("data-is-color");
      row.addEventListener("click", (e) => {
        const b = e.target.closest(OPT_SEL); if (!b) return;
        $$(OPT_SEL, row).forEach((x) => x.classList.remove("active"));
        b.classList.add("active");
        selected[idx] = b.dataset.optionValue;
        if (isColor) {
          const label = productInfo.querySelector('[data-opt-label="' + idx + '"]');
          if (label) label.textContent = b.dataset.optionValue;
        }
        updateVariant();
      });
    });

    // qty stepper
    const qtyInput = $("[data-qty]", productInfo);
    $("[data-qty-down]", productInfo) && $("[data-qty-down]", productInfo).addEventListener("click", () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    $("[data-qty-up]", productInfo) && $("[data-qty-up]", productInfo).addEventListener("click", () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    // add to cart (AJAX)
    if (form) {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const errEl = $("[data-form-error]", productInfo);
        if (errEl) errEl.classList.remove("show");
        if (addBtn) addBtn.disabled = true;
        const data = new FormData(form);
        fetch(routes.cart_add_url + ".js", { method: "POST", headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: data })
          .then((r) => { if (!r.ok) return r.json().then((x) => { throw x; }); return r.json(); })
          .then(() => refreshCart())
          .then(() => { if (addBtn) addBtn.disabled = false; openDrawer(); toast(window.cartStrings.added); })
          .catch((err) => { if (addBtn) addBtn.disabled = false; if (errEl) { errEl.textContent = (err && err.description) || window.cartStrings.error; errEl.classList.add("show"); } });
      });
    }
    // sticky add mirrors the form submit
    if (stickyAdd && form) stickyAdd.addEventListener("click", () => { form.requestSubmit ? form.requestSubmit() : form.querySelector("[data-add-btn]").click(); });

    updateVariant();

    /* gallery thumbs */
    const thumbs = $("[data-thumbs]", productInfo);
    if (thumbs && mainImg) {
      thumbs.addEventListener("click", (e) => {
        const t = e.target.closest(".pdp-thumb"); if (!t) return;
        $$(".pdp-thumb", thumbs).forEach((x) => x.classList.remove("active"));
        t.classList.add("active");
        if (t.dataset.img) mainImg.src = t.dataset.img;
      });
    }

    /* image hover zoom */
    const mainBox = $(".pdp-main", productInfo);
    if (mainBox && mainImg && window.matchMedia("(hover:hover)").matches) {
      mainBox.addEventListener("mousemove", (e) => {
        const r = mainBox.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
      });
      mainBox.addEventListener("mouseenter", () => mainBox.classList.add("zoom"));
      mainBox.addEventListener("mouseleave", () => mainBox.classList.remove("zoom"));
    }

    /* sticky add-to-bag bar */
    const sticky = $("[data-pdp-sticky]");
    if (sticky && addBtn && supportsIO) {
      const sObs = new IntersectionObserver((entries) => {
        entries.forEach((en) => sticky.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0));
      }, { threshold: 0 });
      sObs.observe(addBtn);
    }
  }

  /* =================================================================
     POPUP
     ================================================================= */
  const popup = $("[data-popup]");
  if (popup) {
    const close = () => { popup.classList.remove("open"); };
    const store = {
      get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    // once per 30 days; never for someone who has already added to cart this visit
    const last = parseInt(store.get("wc_popup_at"), 10) || 0;
    const monthMs = 30 * 24 * 60 * 60 * 1000;
    const eligible = (Date.now() - last > monthMs) && !window.wcAddedToCart;
    let fired = false;
    const open = () => {
      if (fired || window.wcAddedToCart) return;
      fired = true;
      store.set("wc_popup_at", String(Date.now()));
      popup.classList.add("open");
    };
    if (eligible) {
      // 30 seconds OR 40% scroll, whichever comes first — never immediately on load
      const delay = Math.max(5000, parseInt(popup.dataset.popupDelay, 10) || 30000);
      const timer = setTimeout(open, delay);
      const onScrollDepth = () => {
        const h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= 0.4) {
          clearTimeout(timer);
          window.removeEventListener("scroll", onScrollDepth);
          open();
        }
      };
      window.addEventListener("scroll", onScrollDepth, { passive: true });
    }
    $$("[data-popup-close]", popup).forEach((b) => b.addEventListener("click", close));
    popup.addEventListener("click", (e) => { if (e.target === popup) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && popup.classList.contains("open")) close(); });
  }

  /* =================================================================
     COLLECTION facets auto-submit + mobile filter drawer
     ================================================================= */
  const facetForm = $("[data-facet-form]");
  if (facetForm) {
    facetForm.addEventListener("change", (e) => {
      if (e.target.matches("[data-auto-submit]")) {
        facetForm.submit();
      }
    });
  }
  const facetPanel = $(".facets");
  const facetScrim = $("[data-facet-scrim]");
  if (facetPanel) {
    const setFilter = (open) => {
      facetPanel.classList.toggle("open", open);
      if (facetScrim) facetScrim.classList.toggle("open", open);
      document.body.style.overflow = open ? "hidden" : "";
    };
    $$("[data-filter-open]").forEach((b) => b.addEventListener("click", () => setFilter(true)));
    $$("[data-filter-close]").forEach((b) => b.addEventListener("click", () => setFilter(false)));
    if (facetScrim) facetScrim.addEventListener("click", () => setFilter(false));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && facetPanel.classList.contains("open")) setFilter(false); });
  }

  /* ---------- Catalogue: products-per-row toggle (desktop, remembered) ---------- */
  const productGrid = $("[data-product-grid]");
  const viewBtns = $$("[data-view]");
  if (productGrid && viewBtns.length) {
    const applyCols = (n) => {
      productGrid.classList.remove("cols-2", "cols-3", "cols-4");
      productGrid.classList.add("cols-" + n);
      viewBtns.forEach((b) => b.classList.toggle("active", b.dataset.view === String(n)));
    };
    let saved = null;
    try { saved = localStorage.getItem("wc_cols"); } catch (e) {}
    if (saved) applyCols(saved);
    viewBtns.forEach((b) => b.addEventListener("click", () => {
      try { localStorage.setItem("wc_cols", b.dataset.view); } catch (e) {}
      applyCols(b.dataset.view);
    }));
  }

  /* =================================================================
     SIZE GUIDE MODAL
     ================================================================= */
  const sizeGuide = $("[data-sizeguide]");
  if (sizeGuide) {
    const openSG = () => { sizeGuide.classList.add("open"); document.body.style.overflow = "hidden"; };
    const closeSG = () => { sizeGuide.classList.remove("open"); document.body.style.overflow = ""; };
    $$("[data-sizeguide-open]").forEach((b) => b.addEventListener("click", openSG));
    $$("[data-sizeguide-close]", sizeGuide).forEach((b) => b.addEventListener("click", closeSG));
    sizeGuide.addEventListener("click", (e) => { if (e.target === sizeGuide) closeSG(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && sizeGuide.classList.contains("open")) closeSG(); });
  }

  /* =================================================================
     SEARCH OVERLAY + PREDICTIVE
     ================================================================= */
  const searchOverlay = $("[data-search-overlay]");
  if (searchOverlay) {
    const sInput = $("[data-search-input]", searchOverlay);
    const sResults = $("[data-search-results]", searchOverlay);
    const sPopular = $("[data-search-popular]", searchOverlay);
    const sClose = $("[data-search-close]", searchOverlay);
    let sTimer;

    const openSearch = () => { searchOverlay.classList.add("open"); document.body.style.overflow = "hidden"; setTimeout(() => sInput && sInput.focus(), 130); };
    const closeSearch = () => { searchOverlay.classList.remove("open"); document.body.style.overflow = ""; };
    const resetSearch = () => { if (sResults) { sResults.classList.remove("show"); sResults.innerHTML = ""; } if (sPopular) sPopular.style.display = ""; };

    $$("[data-search-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openSearch(); }));
    if (sClose) sClose.addEventListener("click", closeSearch);
    searchOverlay.addEventListener("click", (e) => { if (e.target === searchOverlay) closeSearch(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && searchOverlay.classList.contains("open")) closeSearch(); });

    function renderSearch(products, q) {
      if (!sResults) return;
      if (sPopular) sPopular.style.display = "none";
      sResults.classList.add("show");
      if (!products || !products.length) {
        sResults.innerHTML = '<p class="search-empty">No matches for &ldquo;' + esc(q) + '&rdquo;. Try another search.</p>';
        return;
      }
      const cards = products.map((p) => {
        const img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || "");
        const imgTag = img ? '<img src="' + sizedImg(img, 360) + '" alt="" loading="lazy">' : "";
        const priceVal = p.price ? formatMoney(p.price) : "";
        const price = priceVal ? '<div class="ps-price">' + priceVal + "</div>" : "";
        return '<a class="ps-card" href="' + p.url + '"><div class="ps-img">' + imgTag + '</div><div class="ps-name">' + esc(p.title) + "</div>" + price + "</a>";
      }).join("");
      const searchUrl = (routes.search_url || "/search");
      const more = '<a class="ps-more" href="' + searchUrl + "?q=" + encodeURIComponent(q) + '">See all results</a>';
      sResults.innerHTML = '<p class="eyebrow">Products</p><div class="ps-grid">' + cards + "</div>" + more;
    }

    function doSearch(q) {
      const base = routes.predictive_search_url || "/search/suggest";
      const url = base + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url, { headers: { "Accept": "application/json" } })
        .then((r) => r.json())
        .then((data) => {
          const products = (data && data.resources && data.resources.results) ? data.resources.results.products : [];
          renderSearch(products, q);
        }).catch(() => {});
    }

    if (sInput) {
      sInput.addEventListener("input", () => {
        const q = sInput.value.trim();
        clearTimeout(sTimer);
        if (q.length < 2) { resetSearch(); return; }
        sTimer = setTimeout(() => doSearch(q), 220);
      });
    }
  }

  /* =================================================================
     SALE COUNTDOWN — [data-countdown data-until="YYYY-MM-DD HH:MM"]
     ================================================================= */
  const countdowns = $$("[data-countdown]");
  if (countdowns.length) {
    const pad = (n) => (n < 10 ? "0" : "") + n;
    const tick = () => {
      const now = Date.now();
      countdowns.forEach((el) => {
        const raw = (el.dataset.until || "").trim().replace(" ", "T");
        const end = Date.parse(raw);
        if (isNaN(end)) { el.classList.add("cd-done"); return; }
        let diff = Math.max(0, end - now);
        if (diff === 0) { el.classList.add("cd-done"); return; }
        el.classList.remove("cd-done");
        const d = Math.floor(diff / 86400000); diff -= d * 86400000;
        const h = Math.floor(diff / 3600000); diff -= h * 3600000;
        const m = Math.floor(diff / 60000); diff -= m * 60000;
        const s = Math.floor(diff / 1000);
        const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = pad(v); };
        set("[data-cd-d]", d); set("[data-cd-h]", h); set("[data-cd-m]", m); set("[data-cd-s]", s);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* =================================================================
     CAROUSEL ARROWS — [data-carousel-wrap] > [data-car-prev/next] + [data-carousel]
     ================================================================= */
  $$("[data-carousel-wrap]").forEach((wrap) => {
    const track = $("[data-carousel]", wrap);
    if (!track) return;
    const step = () => Math.max(track.clientWidth * 0.75, 240);
    const prev = $("[data-car-prev]", wrap);
    const next = $("[data-car-next]", wrap);
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  });

  /* =================================================================
     COPY DISCOUNT CODE — [data-copy-code="CODE"]
     ================================================================= */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-copy-code]");
    if (!btn) return;
    const code = btn.getAttribute("data-copy-code");
    if (!code) return;
    const done = () => toast("Code " + code + " copied");
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      const ta = document.createElement("textarea");
      ta.value = code; ta.style.position = "absolute"; ta.style.left = "-9999px";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
  });

  /* =================================================================
     DELIVERY ESTIMATE — "Order today, delivered by Tue 29 July"
     1 business day dispatch + 3 business days transit, weekend-aware.
     ================================================================= */
  const deliveryEl = $("[data-delivery-estimate]");
  if (deliveryEl) {
    const addBusinessDays = (date, days) => {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    };
    const eta = addBusinessDays(new Date(), 4); // 1 dispatch + 3 transit
    const fmt = eta.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "long" });
    const textEl = $("[data-delivery-text]", deliveryEl);
    if (textEl) textEl.textContent = "Order today, delivered by " + fmt;
    deliveryEl.hidden = false;
  }

  /* =================================================================
     PRODUCT REVIEWS — show more
     ================================================================= */
  const rvMore = $("[data-reviews-more]");
  if (rvMore) {
    rvMore.addEventListener("click", () => {
      const listEl = $("[data-reviews-list]");
      if (listEl) listEl.classList.add("expanded");
      rvMore.style.display = "none";
    });
  }

  /* ---------- bfcache: returning via Back must not restore a locked/open overlay ---------- */
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted) return;
    document.body.style.overflow = "";
    if (searchOverlay) searchOverlay.classList.remove("open");
    closeDrawer();
    if (facetPanel) { facetPanel.classList.remove("open"); if (facetScrim) facetScrim.classList.remove("open"); }
  });

  /* ---------- init ---------- */
  watchReveals();
})();
